import "./DaPageWrapper.css";
import PropTypes from "prop-types";
import { DaShell } from "../DaShell/DaShell";
import { DaIcon } from "../DaIcon/DaIcon";

const DaPageWrapper = ({ wrapperClass = "da-page-wrapper", iconType, title, subtitle, children }) => {
  const base = wrapperClass.split(" ")[0] || "da-page-wrapper";

  return (
    <DaShell>
      <div className={wrapperClass}>
        {iconType && (
          <div className={`${base}-icon`}>
            <DaIcon type={iconType} />
          </div>
        )}

        {title && <h1 className={`${base}-title`}>{title}</h1>}

        {subtitle && <p className={`${base}-subtitle`}>{subtitle}</p>}

        {children}
      </div>
    </DaShell>
  );
};

DaPageWrapper.propTypes = {
  wrapperClass: PropTypes.string,
  iconType: PropTypes.string,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  children: PropTypes.node,
};

export default DaPageWrapper;
